import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
 const Edible = (props) => (
   <SvgIcon {...props}>
      <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
        M21,12c0,5.161-4.183,9.344-9.344,9.344S2.311,17.161,2.311,12c2.649-0.691,3.858-2.342,4.049-4.672
        c3.543,0.222,5.099-1.544,5.295-4.672C16.817,2.656,21,6.839,21,12z"/>
      <circle fill={props.color} cx="11.033" cy="16.672" r="1.557"/>
      <circle fill={props.color} cx="14.459" cy="8.262" r="1.557"/>
      <circle fill={props.color} cx="8.852" cy="11.377" r="1.246"/>
      <circle fill={props.color} cx="3.246" cy="6.705" r="1.246"/>
      <circle fill={props.color} cx="6.672" cy="3.902" r="0.934"/>
      <circle fill={props.color} cx="16.328" cy="14.18" r="1.246"/>
   </SvgIcon>
);

export default Edible;



// WEBPACK FOOTER //
// ./src/icons/types/Edible.jsx